// =====================================================================
// src/lib/shareBase.js
//
// The ONE place the public Aangan origin is written down.
//
// WHY THIS EXISTS
// ---------------
// Every shareable link (batch invite, business profile, wall post) must be
// openable by someone who does not have the app. `window.location.origin`
// looks like the obvious way to build one, and it is wrong in the case that
// matters most:
//
//   - Web dev      → http://localhost:5173   (recipient gets a dead link)
//   - Capacitor    → http://localhost         (recipient gets a dead link)
//   - Web prod     → https://aangan.aapsaathi.com   (correct, by luck)
//
// On Capacitor native the WebView is served from a local origin, so a
// merchant sharing their business from the Android app hands out a URL that
// resolves to nothing on the recipient's phone. V1's App.jsx worked around
// this years ago with a hardcoded AANGAN_SHARE_BASE and a comment saying
// exactly that — but the V2 surfaces (BusinessProfile, MerchantApp,
// SharePostSheet) each reached for window.location.origin independently.
// Three copies of a bug that V1 had already fixed once.
//
// So: one constant, imported by V1 and V2 alike. If the domain ever moves,
// it moves here.
//
// NOTE ON DEV: share links built in `npm run dev` will point at production.
// That is deliberate. A share link is for someone else, and a localhost URL
// is never useful to them. Test deep-link *parsing* by pasting the path onto
// your dev origin by hand.
// =====================================================================

export const AANGAN_SHARE_BASE = 'https://aangan.aapsaathi.com';

// Join the base with a path, tolerating a leading slash or not.
//
//   buildShareUrl('/biz/sharma-sweets')
//   buildShareUrl('biz/sharma-sweets')
//     → 'https://aangan.aapsaathi.com/biz/sharma-sweets'
export function buildShareUrl(path = '') {
  if (!path) return AANGAN_SHARE_BASE;
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${AANGAN_SHARE_BASE}${suffix}`;
}
